let appName = '亓迪科技'

module.exports = {
    name: appName,
    languagezh: '中文',
    languageen: '英文',
    homeRouter: '首页',
    cheatdefenderRouter: 'CheatDefender',
    aboutRouter: '关于我们',
    contactRouter: '联系我们',
    footer: '上海亓迪科技有限公司',
    home: {
        bannerTitle: '一站式产品技术解决方案',
        text1: '互联网项目从0到1的设计开发服务',
        text2: '累计上线案例40+',
        module1: {
            title: '服务支持',
            titleDesc: '品牌建站、集团建站、营销型网站、平台型网站、响应式网站、手机端网站、多媒体H5设计开发',
        },
        moduleList1: {
            title1: '移动端设计开发',
            text1: '根据需求设计风格，定制开发解决方案，从设计到开发功能需求到测试上线，高效交付。',
            title2: '交互设计',
            text2: '以用户体验为基础进行人机交互，使得用户在使用产品时愉悦，创造出用户黏度。',
            title3: '高端网站定制',
            text3: '专业的设计开发团队和流程规范，让所有企业在最短时间内拥有一套高端的网站。',
            title4: '优化运营',
            text4: '数据分析驱动产品策略、投放管理，让企业的业务方向规划更加智能。',

        },
        module2: {
            title: '精品案例',
            titleDesc: '将商业策划、创意艺术、互联网技术与营销数据分析完美融合'
        },
        moduleList2: {
            title1: '人狗翻译器 APP',
            title2: 'FT微关爱 APP',
            title3: '易联家政 APP',
            title4: '多开分身免费版 APP',
            title5: '律科金融 官网',
            title6: '星河科技 官网',
        },
        module3: {
            title: '关于我们',
            titleDesc: '致力于为用户提供易用，美观，创新的高价值产品和服务'
        },
        moduleList3: {
            text1: '上海亓迪科技有限公司成立于2022年，是互联网技术服务的专业公司，拥有超强的行业资讯和项目实施能力，致力于为用户提供易用，美观，创新的高价值产品和服务。 亓迪坚持为客户创造更多的商业价值，并通过互联网技术与行业结合，加速行业创新，助力增长，优化运营，提高效率，升级客户体验助力客户创造更多的商业价值。亓迪提供领先的数字化咨询，用户体验设计，技术实施和运营服务，在项目管理和交付有丰富的沉淀，凭借在高科技，金融，教育，消费，共享，智能硬件，大数据等行业深厚积累， 并与多家优秀企业建立了长期合作关系。',
            text2: '了解更多',
        },

        module4: {
            title: '我们的优势',
            titleDesc: '拒绝低价低质的行业现状，为您打造高端网站'
        },
        moduleList4: {
            title1: '丰富的经验',
            text1: '服务不同行业项目，一致得到业内好评。',
            title2: '快速落地',
            text2: '根据需求， 落实产品相关事宜， 快速上线',
            title3: '持续更新',
            text3: '配合企业需求与发展规划， 对产品进行升级与优化。',
            title4: '服务优质',
            text4: '专业、 高效的服务团队， 快速响应',
        },
        module5: {
            title: '合作伙伴',
            titleDesc: '以跨领域的互联网嗅觉，与用户一起创造奇迹'
        },
        moduleList5: {
            text1: '律科金融',
            text2: '轻轻家政',
            text3: '顺凡管理',
            text4: '善若科技',
            text5: '星河科技',
            text6: '爱尚屋',
            text7: '易联金融',
            text8: '爱奇文化'
        },

    },
    solve: {
        bannerTitle: '游戏反作弊防御系统',
        text1: 'Cheatdefender 一款基于成熟商业软件保护系统的',
        text2: '网络应用作弊防御方案',
        module1: {
            title: 'CheatDefender',
            titleDesc: '数据包加密和解密',
        },
        moduleList1: {
            text1: "CheatDefender是一款基于成熟商业软件保护系统的网络应用作弊防御方案，包含关键代码的变形、乱序、虚拟化，运行时的反调试、反附加、动态自效验，结合服务端动态代码下发、通讯加密和实时代码虚拟化技术，全面满足C/S模式应用的安全需求。",
        },
        module2: {
            title: 'CheatDefender 简介'
        },
        moduleList2: {
            title1: '封包加密解密',
            text1: '最基本的功能之一，对游戏的封包进行加密解密，使一些游戏协议分析工具如WPE等全部失效。',
            title2: '防止封包重放',
            text2: '一些有经验的攻击者，会利用封包重放的原理，来分析封包加密解密算法。而CD的封包加密解密算法，可以保证相同数据的加密结果不同。',
            title3: '客户端代码和关键数据校验',
            text3: '下发的客户端代码，可以实时对游戏客户端的代码和关键数据进行校验，防止游戏客户端被恶意篡改。',
            title4: '防止客户端加速',
            text4: '校验游戏客户端时间，防止客户端恶意加速，破坏游戏平衡。',
            title5: '自动扫描外挂',
            text5: '下发的客户端代码，可以实时扫描隐藏在客户端中的外挂，让外挂无处藏身。',
            title6: '不停机更新所有功能',
            text6: 'CheatDefender独创的动态更新功能，可以在客户端和服务端都不停机的情况下更新以上五大功能，让游戏的业务不会因为反作弊系统而中断。',
        },

        module3: {
            title: 'CheatDefender 构架'
        },
        moduleList3: {
            text1: '服务端 -> 客户端',
            text2: '客户端 -> 服务端',
        },
        module4: {
            title: '联系我们',
            titleDesc: '我们可以为您解决任何问题',
        },
        moduleList4: {
            text1: '联系人邮箱：    ',
            text2: '海外市场经理邮箱：'
        }
    },
    about: {
        bannerTitle: '关于我们',
        text1: '致力于为用户提供易用，美观，创新的高价值产品和服务',
        module1: {
            title: '我们的团队',
        },
        moduleList1: {
            text1: '上海亓迪科技有限公司成立于2022年，是互联网技术服务的专业公司，拥有超强的行业资讯和项目实施能力，致力于为用户提供易用，美观，创新的高价值产品和服务。亓迪坚持为客户创造更多的商业价值，并通过互联网技术与行业结合，加速行业创新，助力增长，优化运营，提高效率，升级客户体验助力客户创造更多的商业价值。亓迪提供领先的数字化咨询，用户体验设计，技术实施和运营服务，在项目管理和交付有丰富的沉淀，凭借在高科技，金融，教育，消费，共享，智能硬件，大数据等行业深厚积累，并与多家优秀企业建立 了长期合作关系。',
            text2: '团队成员拥有国内外知名IT及互联网企业工作经历，在技术研发、项目管理、产品运营等领域具有丰富的开发管理经验与优势。既具有广阔的视野、全球性的思维模式，又深度理解本土化、地域性需求。',
            text3: '专业领域精英（人）',
            text4: '知名品牌（个）',
            text5: '项目经验（年）'
        },
        module2: {
            title: '公司文化',
        },
        moduleList2: {
            text1: '乐于分享',
            text2: '执行迅速',
            text3: '保持好奇',
            text4: '信任同事与客户'
        },
        module3: {
            title: '我们的未来',
        },
        moduleList3: {
            text1: '未来五年，亓迪坚持以“用户体验至上”，结合“互联网+”带动行业发展，立志积极打造一个生态型的互联网平台着力于在数字内容开发、企业管理SAAS平台、大数据应用和智慧物联等领域开发系列产品及应用。',
        },
    },
    contact: {
        bannerTitle: '联系我们',
        text1: '卓越品质、经营求精，为您提供最诚挚的服务',
        module1: {
            title: '上海亓迪科技有限公司',
        },
        moduleList1: {
            phone: '13402089914',
            email: '2090623970(at)qq.com',
            text1: '地址: 上海市松江区茸梅路158号 A2101',
            text2: '邮编: 201600'
        }
    },
}